import React from 'react';
import {HandleType, NodeProps} from 'reactflow';

import SimpleBenchlingNode from 'ui-library/reactflow/nodes/SimpleBenchlingNode/SimpleBenchlingNode';

export interface UnitOperationFields {
  pmeiId: string;
  procedureRunName: string | null;
  methodName: string;
  conditionName: string;
  replicateNumber: number;
}

export default function UnitOperationFlowchartNode({
  data,
  ...props
}: NodeProps<UnitOperationFields & {handleType: HandleType}>): JSX.Element {
  const {methodName, procedureRunName, conditionName, replicateNumber} = data;
  return (
    <SimpleBenchlingNode
      {...props}
      data={{
        nodeHandleCustomizations: {
          defaultNodeHeaderHandleOverrides: {
            nodeHeaderHandleIdGenerator: (nodeId: string, handleType: HandleType) =>
              handleType === data.handleType ? `${nodeId}-${handleType}` : null,
          },
        },
        hideSectionSummaries: true,
        nodeName: methodName,
        nodeSecondaryInfo: procedureRunName ?? '',
        sections: [
          {
            sectionName: `${conditionName} - ${replicateNumber}`,
            sectionRows: [],
          },
        ],
      }}
    />
  );
}
